import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { withFeatureToggles } from 'shell/hoc/withFeatureToggles';
import { GROUPS_MANAGEMENT } from 'constants/featureToggleNames';
import ClientListItemEmpty from './ClientListItemEmpty';
import styles from './ClientListItemEmpty.styles';

export default compose(
  withRouter,
  withStyles(styles),
  withFeatureToggles({
    isGroupsManagementEnabled: GROUPS_MANAGEMENT,
  }),
)(ClientListItemEmpty);
